// 履约提货确认
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import { Card, Button, Radio, Popup, Dialog } from 'antd-mobile'
import { AddressEntry } from '../Address/AddressEntry'
import { Container, Header, Wrapper, Footer } from '../../components_renew/Layout'
import { YenSpan } from '../../components_renew/common/YenSpan'
import { ConfirmButton } from '../../components_renew/Mall/Buttons'
import { filterCouponWithProductId } from '../../utils/filterTicketWithProduct'
import { setOrderConfirmCoupon, setOrderConfirmData } from '../../actions/mallAction'
// import { requestCouponData } from '../../actions/couponAction'
import { handleCatch, postMessage } from '../../utils'
import api from '../../api'

class OrderConfirmItem extends React.PureComponent {

  // state = { extra: '点击选择折扣券' }

  // componentDidUpdate (prevProps, prevState, snapshot) {
  //   let { ticketUsable, selectedTicket } = this.props
  //   if (ticketUsable && (prevProps.selectedTicket !== selectedTicket)) {
  //     let extra = selectedTicket ? selectedTicket['couponDesc'] : '点击选择折扣券'
  //     this.setState({ extra })
  //   }
  // }

  render () {
    const {
      productName, productCount, currentPrice, productPic, couponData, couponList,
      onCouponClick
    } = this.props
    if (couponList) {
      console.group('confirm item render')
      console.log(this.props)
      console.groupEnd()
    }
    // let { extra } = this.state
    return <Card className={'m-4'}>
      <div className={'flex'}>
        <img className={'h-auto w-24'} src={productPic} alt=""/>
        <div className={'flex-auto ml-4'}>
          <div className={'line-clamp-2 mb-4'}>
            {productName}
          </div>
          <div className={'flex justify-between'}>
            <YenSpan>{currentPrice}</YenSpan>
            <div className={'text-sm'} style={{ color: 'var(--adm-color-weak)' }}>
              x {productCount}
            </div>
          </div>
        </div>
      </div>
      {
        couponList && couponList.length > 0
          ?
          <div className={'flex justify-end items-center'}>
            <Button size={'mini'}
                    fill={'outline'}
                    color={'primary'}
                    onClick={onCouponClick}
            ><i className={'icon-font icon-arrow-down-bold'}/>
              &nbsp;
              {couponData ? couponData['couponDesc'] : '点击选择折扣券'}
            </Button>
          </div>
          : null
      }
      <br/>
      {
        (couponData && couponData['value'])
          ? <div className={'flex justify-end items-center text-xs text-gray-500'}>
            折扣券抵扣 {couponData['label']}
          </div>
          : null
      }
    </Card>
  }
}

@connect(state => {
    let { addressData, couponData, mallOrderConfirm } = state
    return {
      addressData: addressData.selectedAddress,
      mallCoupon: couponData.mallCoupon,
      ...mallOrderConfirm
    }
  }
)
@withRouter
class AgreementDeliveryConfirm extends React.PureComponent {

  loading = false
  // render里productList.map()时进行计算，不再每次state或者props更改时判断是否重新计算
  total = 0
  pendingData = []

  state = {
    // ？
    // total: 0,
    // pendingData: [],
    // idMapCoupon: {}, // ? 无用?

    // modal
    modalVisible: false,
    commonVisible: false,
    // // 通用券列表
    // ticketCommonList: [],
    // ticketCommonSelect: { couponId: '', couponDesc: '不使用' },
    // 判断是否选用了通用券
    isCommon: Boolean(this.props.selectedCommonCoupon['value']),

    productList: this.props.productList,

    // 2024/1/8 改为履约提货券，数据源自productCoupon里，所以逻辑也类似
    agreementCouponList: [],

    // 默认的通用券选项
    selectedCommonCoupon: {},

    // 商品Id(非productId)对应couponItem的map
    // 该对象才是控制哪个商品选择了哪个券，如直接下单里跳转过来，可直接通过该对象控制页面里选择了哪张券
    selectedCouponMap: {}, // {id: couponItem}

    // 通用券列表在store里
    // 零售券列表，在mount和update时筛选出对应的couponMap
    productCouponList: [],

    // 当前product下选择的couponId
    selectedCouponId: '',
    // 当前modal的productId
    currentProductId: '',

  }

  componentDidMount () {

    api.agreement.fetchAgreementDeliveryTicket()
      .then(res => {
        // 拿到数据后便给他选上这个券
        const couponList = res.map(item => {
          const { faceValue, couponId, ...coupon } = item
          Object.assign(coupon, {
            couponId,
            label: `${faceValue} 元`,
            value: couponId,
            price: Number(faceValue)
          })
          return coupon
        })
        this.setState({ agreementCouponList: couponList },
          () => {
            // 得把处理步骤移到setState后而不是finally，不然出现券还没set完就开始处理逻辑...
            let { productList } = this.props
            if (!(productList.length > 0)) {
              // 若无商品详情，先去获取
              this.props.dispatch(setOrderConfirmData({
                productList: JSON.parse(localStorage.getItem('productList')),
                selectedCouponMap: JSON.parse(localStorage.getItem('selectedCouponMap'))
              }))
            } else {
              // 若有商品，则去匹配对应的券
              let { productList, selectedCouponMap } = this.handleCoupon()
              this.setState({ productList, selectedCouponMap })
            }
          })
      })
      .catch(e => e)
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if ((prevProps.productList !== this.props.productList)) {
      // 若商品改变，重新筛选券
      let { productList, selectedCouponMap } = this.handleCoupon()
      this.setState({ productList, selectedCouponMap })
    }
  }

  componentWillUnmount () {
    // 只为退出该页面时记录一下券的状态，以便返回或者跳去选择地址时不用重新选择
    this.props.dispatch(setOrderConfirmCoupon({
      selectedCommonCoupon: this.state.selectedCommonCoupon,
      selectedCouponMap: this.state.selectedCouponMap
    }))
  }

  handleCoupon = () => {
    const selectedCouponMap = {}
    // 筛选出哪个商品能用哪个票
    let productList = this.props.productList.map((item) => {
      let couponList = filterCouponWithProductId(item['productId'], this.state.agreementCouponList)
      if (couponList.length > 0) {
        Object.assign(item, { couponUsable: true, couponList })
        Object.assign(selectedCouponMap, {
          [item.id]: couponList[0]
        })
      }
      return item
    })
    return { productList, selectedCouponMap }
  }

  render () {
    let {
      modalVisible,
      // commonVisible,
      // selectedCommonCoupon,
      selectedCouponId,
      productCouponList
    } = this.state
    // console.group('Confirm render')
    // console.log(productCouponList)
    // console.log(selectedCouponId)
    // console.log(this.state)
    // console.groupEnd()

    let { productList, total, amount } = this.handlePendingData()
    return <Container>
      <Header>确认订单</Header>
      <Wrapper flex>
        <AddressEntry/>
        <br/>
        {productList}
        {/*  通用券*/}
        {/*{*/}
        {/*  commonCoupon.length > 0 &&*/}
        {/*  <Card style={{ minHeight: 'unset' }} className={'item-card item-card--margin-bottom'}>*/}
        {/*    <Card.Header title={'通用券'} />*/}
        {/*    <Card.Body style={{ minHeight: 'unset' }}>通用券与商品折扣券只能同时使用其中一种<br />通用券按整张订单价格进行折扣</Card.Body>*/}
        {/*    <Card.Footer onClick={this.onCommonClick} extra={<div className='item-card__extra'><i*/}
        {/*      className={'icon-font icon-arrow-down-bold'} /> {selectedCommonCoupon['couponDesc']}*/}
        {/*    </div>} />*/}
        {/*  </Card>*/}
        {/*}*/}
      </Wrapper>
      <Footer className={'justify-between'}>
        <div style={{ padding: '1rem' }}>
          <span>共 {amount} 件&emsp;合计： </span>
          <YenSpan>{total}</YenSpan>
        </div>
        <ConfirmButton type={'danger'} onClick={this.confirmOrder}>&emsp;提交订单&emsp;</ConfirmButton>
      </Footer>
      {/*折扣券*/}
      <Popup
        visible={modalVisible}
        onClose={this.closeModal}
        showCloseButton
        closeOnMaskClick
        bodyClassName={'p-2'}
      >
        <div className={'text-lg font-bold mb-4'}>请选择折扣券</div>
        <div className={'flex flex-col max-h-[80vh] overflow-y-auto'}>
          {/*<RadioItem checked={selectedCouponId === ''}*/}
          {/*           onChange={this.onCouponPickerChange.bind(this, { couponId: '', couponDesc: '不使用' })}>*/}
          {/*  不使用*/}
          {/*</RadioItem>*/}
          {productCouponList.map((item, index) => (
            item['used']
              ? null
              : <Radio key={index}
                       className={'mb-4'}
                       checked={item['couponId'] === selectedCouponId}
                       onChange={this.onCouponPickerChange.bind(this, item)}>
                {item['couponDesc']}
              </Radio>
          ))}
        </div>
      </Popup>

      {/*通用券*/}
      {/*<Modal*/}
      {/*  popup*/}
      {/*  title={'请选择通用卷'}*/}
      {/*  className={'popup-list__modal'}*/}
      {/*  visible={commonVisible}*/}
      {/*  onClose={this.closeModal}*/}
      {/*  animationType='slide-up'*/}
      {/*  closable*/}
      {/*>*/}
      {/*  <List className='popup-list__main'>*/}
      {/*    <RadioItem checked={selectedCommonCoupon['couponId'] === ''}*/}
      {/*               onChange={this.onCommonTicketChange.bind(this, { couponId: '', couponDesc: '不使用' }, false)}>*/}
      {/*      不使用*/}
      {/*    </RadioItem>*/}
      {/*    {commonCoupon.map((item, index) => (*/}
      {/*      <RadioItem key={index} checked={item['couponId'] === selectedCommonCoupon['couponId']}*/}
      {/*                 onChange={this.onCommonTicketChange.bind(this, item, true)}>*/}
      {/*        {item['couponDesc']}*/}
      {/*      </RadioItem>*/}
      {/*    ))}*/}
      {/*  </List>*/}
      {/*</Modal>*/}
    </Container>
  }

  closeModal = () => this.setState({ modalVisible: false, commonVisible: false })

  onCommonClick = () => {this.setState({ commonVisible: true })}

  onCouponClick = (productItem) => {
    let { couponList, id } = productItem
    let { selectedCouponMap } = this.state
    // 判断券是否在其他商品使用
    let selectedCouponList = []
    let selectedCouponId = ''
    // 有问题
    for (let key in selectedCouponMap) {
      if (selectedCouponMap.hasOwnProperty(key)) {
        // console.log('id === key ?', id, key)
        // console.log(typeof id, typeof key)
        // 我们协定id和key都必须为string
        if (String(id) === String(key)) {
          selectedCouponId = selectedCouponMap[key] ? selectedCouponMap[key]['couponId'] : ''
        } else {
          selectedCouponList.push(selectedCouponMap[key])
        }
      }
    }
    let productCouponList = couponList.map(item => ({
      ...item,
      used: Boolean(selectedCouponList.find(i => i['couponId'] === item['couponId']))
    }))
    this.setState({
      modalVisible: true,
      currentProductId: id,
      productCouponList,
      selectedCouponId
    })
  }

  onCouponPickerChange = coupon => {
    if (coupon['used']) return
    let selectedCouponMap = _.cloneDeep(this.state.selectedCouponMap)
    // let selectedCouponMap = {...this.state.selectedCouponMap}
    let { currentProductId } = this.state
    selectedCouponMap[currentProductId] = coupon['couponId'] ? coupon : undefined
    this.setState({ selectedCouponMap, selectedCouponId: coupon['couponId'], modalVisible: false })
  }

  onCommonTicketChange = (coupon, isCommon) => {
    this.setState({ commonVisible: false, selectedCommonCoupon: coupon, isCommon })
  }

  handlePendingData = () => {
    let { isCommon, selectedCouponMap, selectedCommonCoupon, productList } = this.state
    let total = 0
    let amount = 0
    let pendingData = []
    if (isCommon) {
      // 处理使用通用券的逻辑
      productList = productList.map((item, key) => {
        let { currentPrice, productCount, productName, id, productId, state } = item
        let pendingItem = {
          productCount,
          productId,
          productName,
          // 这几个并非必传，传了是为了服务端将商品从购物车中剔除？
          // id: index ? index : undefined,
          id,
          state: state ? state : undefined
        }
        let price = Number(currentPrice) * productCount
        total += price
        amount += productCount
        pendingData.push(pendingItem)
        return <OrderConfirmItem key={key} {...item}
                                 isCommon={isCommon}
                                 couponData={selectedCouponMap[item['id']]}
                                 onCouponClick={this.onCouponClick.bind(this, item)}/>
      })
      let count = Number(selectedCommonCoupon['price'])
      total -= count
      if (total < 0) total = 0
    } else {
      // 处理使用零售券的逻辑
      productList = productList.map((item, key) => {
        let { id, productId, state, currentPrice, productCount, productName } = item
        let pendingItem = {
          productCount,
          id,
          productId,
          productName,
          // id: index ? index : undefined,
          state: state ? state : undefined
        }
        // 一张券只能用一种商品
        let price = Number(currentPrice) * productCount
        if (selectedCouponMap[id]) {
          let value = Number(selectedCouponMap[id]['price'])
          price = price - value
          if (price < 0) { price = 0}
          Object.assign(pendingItem, {
            couponFlag: 1,
            couponId: selectedCouponMap[id]['couponId']
          })
        }
        amount += productCount
        total += price
        pendingData.push(pendingItem)
        return <OrderConfirmItem key={key} {...item}
                                 isCommon={isCommon}
                                 couponData={selectedCouponMap[item['id']]}
                                 onCouponClick={this.onCouponClick.bind(this, item)}/>
      })
    }
    // 处理完券的计算后，设置this.total, this.pendingData以备confirm时使用
    this.total = total
    this.pendingData = pendingData

    // 输出要渲染的productList和amount
    return { productList, amount, total }
  }

  // 结算
  confirmOrder = () => {
    let { addressData } = this.props
    let { selectedCouponMap } = this.state
    const { productId, productCount, productName, couponId, id } = this.pendingData[0]

    if (!addressData || !addressData['id']) {
      window.toast.info('请选择收获地址', 1)
      return
    }
    const params = {
      addressId: addressData['id'],
      couponFlag: 1,
      couponId,
      couponName: selectedCouponMap[id] ? selectedCouponMap[id]['couponDesc'] : '',
      productId,
      productName,
      productNum: productCount
    }
    window.toast.show('下单中...')
    api.agreement.postAgreementDelivery(params)
      .then(() => {
        // window.toast.success('履约提货成功', 1, () => {
        //   postMessage({ type: window.POST_TYPE.CLOSE })
        // })
        window.toast.hide()
        Dialog.alert(
          {
            title: '履约提货成功',
            content: '您的订购权限限制已解除',
            closeOnMaskClick: true,
            onConfirm: () => {
              postMessage({ type: window.POST_TYPE.CLOSE })
            }
          })
          .then(() => {})
      })
      .catch(handleCatch.bind(this))

    // return
    // let config = {
    //   method: 'post',
    //   url: window.API.Mall.postOrder,
    //   data: {
    //     address: {
    //       id: addressData['id'],
    //       flag: addressData['flag'],
    //       isDefault: addressData['isDefault'],
    //       region: addressData['region'],
    //       receivingAddress: addressData['address'],
    //       receivingMobile: addressData['phone'],
    //       receivingName: addressData['name']
    //     },
    //     carList: this.pendingData,
    //     couponFlag: isCommon ? 1 : 0,
    //     couponId: isCommon ? selectedCommonCoupon['couponId'] : '',
    //     totalPrice: this.total
    //   }
    // }
    // window.toast.hide()
    // window.axios.request(config)
    //   .then(orderId => {
    //     window.toast.success('下单成功', 1, () => {
    //       this.props.dispatch(setOrderListRefresh())
    //       this.props.history.replace(`${window.PATH.MALL_ORDER_PAY}/${orderId}`)
    //     })
    //   })
    //   .catch(handleCatch)
    // // .finally(() => this.loading = false)
  }
}

export { AgreementDeliveryConfirm }
